import { Button, Col, DatePicker, Input, Row, Select, Space, Table } from 'antd';

import API from 'api';
import SectionTitle from 'components/OnBoarding/SectionTitle';
import PaginationItemRender from 'constants/PaginationItemRender';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import Actions from './components/Actions';

import styles from './Deals.module.css';

const { RangePicker } = DatePicker;

export default function Deals() {
  const [report, setReport] = useState('');
  const [deals, setDeals] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [filters, setFilters] = useState({});
  const [params, setParams] = useState({});

  const columns = [
    {
      dataIndex: 'actions',
      render: (_, el) => <Actions isReport meta={{ ...el, id: el['Deal ID'], status: el?.Status?.toLowerCase() }} />,
      title: '',
    },
    { title: 'Deal ID', dataIndex: 'Deal ID', key: 'Deal ID' },
    { title: 'Street', dataIndex: 'Street', key: 'Street' },
    { title: 'City', dataIndex: 'City', key: 'City' },
    { title: 'State', dataIndex: 'State', key: 'State' },
    { title: 'Referrer ID', dataIndex: 'Referrer ID', key: 'Referrer ID' },
    { title: 'Borrower POC', dataIndex: 'Borrower POC', key: 'Borrower POC' },
    { title: 'Borrower', dataIndex: 'Borrower', key: 'Borrower' },
    { title: 'Broker Company', dataIndex: 'Broker Company', key: 'Broker Company' },
    { title: 'Broker', dataIndex: 'Broker', key: 'Broker' },
    { title: 'Lender', dataIndex: 'Lender', key: 'Lender' },
    { title: 'LAE', dataIndex: 'LAE', key: 'LAE' },
    { title: 'Loan Request', dataIndex: 'Loan Request', key: 'Loan Request' },
    { title: 'Loan Amount Funded', dataIndex: 'Loan Amount Funded', key: 'Loan Amount Funded' },
    { title: 'Purpose', dataIndex: 'Purpose', key: 'Purpose' },
    { title: 'Property Type', dataIndex: 'Property Type', key: 'Property Type' },
    { title: 'Date submitted', dataIndex: 'Date submitted', key: 'Date submitted' },
    { title: 'Date launched', dataIndex: 'Date launched', key: 'Date launched' },
    { title: 'Date selected', dataIndex: 'Date selected', key: 'Date selected' },
    { title: 'Date funded', dataIndex: 'Date funded', key: 'Date funded' },
  ];

  useEffect(() => {
    API()
      .get('/superadmin/user/LARs/report', {
        params: {
          page: pagination.current,
          per_page: pagination.pageSize,
          output_format: 'json',
          ...params,
        },
      })
      .then((res) => {
        setDeals(res.data?.lars);
        setPagination((prevState) => ({ ...prevState, total: res.data.total }));
      });
  }, [params, pagination.current, pagination.pageSize]);

  useEffect(() => {
    API()
      .get('/superadmin/user/LARs/report')
      .then((res) => {
        setReport(res.data);
      });
  }, []);

  const handleChangeFilters = (name) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleApplyFilters = () => {
    setParams({
      ...filters,
      status_name: (filters?.status_name || []).join(','),
    });
  };

  const handleClearFilters = () => {
    setFilters({});
    setParams({});
  };

  return (
    <div className="prospects_page_wrapper table_with_header_wrapper table_with_pagination_wrapper">
      <Row gutter={[20, 15]} justify="space-between" align="middle">
        <Col>
          <SectionTitle title="Deals" />
        </Col>
        <Col>
          <CSVLink
            size="large"
            className="btn_default btn_darkblue"
            filename={`Starport Deal Report ${moment().format('MMM DD YYYY')}`}
            data={report}
          >
            Export CSV
          </CSVLink>
        </Col>
        <Col span={24}>
          <Row gutter={10}>
            <Col span={5}>
              <Select
                allowClear
                mode="multiple"
                className={styles.select}
                placeholder="Select a status"
                options={[
                  'Incomplete',
                  'Draft',
                  'Active',
                  'Pending Review',
                  'Pre Auction',
                  'PLA Review',
                  'Launch Approved',
                  'Invites Sent',
                  'Live Auction',
                  'Quote Selection',
                  'Loan Processing',
                ].map((r) => ({ value: r, label: r }))}
                value={filters.status_name}
                onChange={handleChangeFilters('status_name')}
              />
            </Col>
            <Col>
              <RangePicker
                onChange={(v) => {
                  handleChangeFilters('created_date_from')(v ? moment(v[0]).format('DD/MM/YYYY') : undefined);
                  handleChangeFilters('created_date_to')(v ? moment(v[1]).format('DD/MM/YYYY') : undefined);
                }}
              />
            </Col>
            <Col span={5}>
              <Input placeholder="Referral id" onChange={(e) => handleChangeFilters('company_name')(e.target.value)} />
            </Col>
            <Col span={5}>
              <Input placeholder="Company" onChange={(e) => handleChangeFilters('company_name')(e.target.value)} />
            </Col>
            <Col>
              <Space>
                <Button
                  type="primary"
                  className="btn_darkblue"
                  disabled={!Object.values(filters).filter((i) => i).length}
                  onClick={handleApplyFilters}
                >
                  Apply
                </Button>
                <Button
                  type="primary"
                  className="btn_darkblue"
                  disabled={!Object.values(params).filter((i) => i).length}
                  onClick={handleClearFilters}
                >
                  Clear
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="section_table_wrapper table_with_header table_with_pagination">
        <Table
          rowKey="id"
          columns={columns}
          dataSource={deals}
          pagination={{
            showSizeChanger: true,
            current: pagination.current,
            total: pagination.total ?? null,
            itemRender: PaginationItemRender,
          }}
          className={styles.table}
          scroll={{ x: 1500 }}
          onChange={setPagination}
        />
      </div>
    </div>
  );
}
